import { useEffect, useState } from "react";
import { IObservable } from "thrive-observable";

/*
	we pass the observable into the hook
	and initialise state with the observable values
*/

function useObservable<T>(observable: IObservable<T>) {
    const [state, setState] = useState<T>(observable.value);

    useEffect(() => {
        const setValueFromObservable = (value: T) => {
            setState(value);
        };

        observable.subscribe(setValueFromObservable);
        return () => {
            observable.unsubscribe(setValueFromObservable);
        };
    }, [observable]); // include observable as dependency

    return state;
}

export default useObservable